<template>
	<div>
		<case-form :schema="schema" />
	</div>
</template>

<script>
import CaseForm from "../../CaseForm/CaseForm.vue"

export default {
	name: "CBProposalStrongRoom",
	components: { CaseForm },
	data() {
		return {
			schema: [
				{
					label: "14. (a) Is there a Strong Room?",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StrongRoomId",
					props: {
						suggest: {
							typeIncludes: "strongRoom"
						},
						createOptions: {
							type: "strongRoom",
							dataType: "string"
						}
					}
				},
				{
					label: "14. (b) If so, give full details.",
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: "case.facts.insured0StrongRoomDetailsId",
					props: {
						suggest: {
							typeIncludes: "strongRoomDetails"
						},
						createOptions: {
							type: "strongRoomDetails",
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
